import Vue from 'vue'
import App from './App.vue'
import router from './router'
import filters from './filters' // eslint-disable-line

// CSS - TODO: Distribute into the Single File Components
import scss from './main.scss' // eslint-disable-line 

if (process.env.NODE_ENV === 'development') {
    import('bootstrap/dist/css/bootstrap.min.css');
} 

// If you're as confused as I am about acronyms...
// Go here: https://www.seattle.gov/council/committees/select-budget-committee/glossary-of-terms

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
